import React from 'react';

const Footer = () => {
    const isApp = window.matchMedia('(display-mode: standalone)').matches
        || window.navigator.standalone === true;

    if (isApp) {
        return null;
    }
    return (
        <footer className="text-white py-4 mt-auto"
            style={{
                background: 'linear-gradient(135deg, #8B0000 0%, #B22222 100%)',
                borderTop: '3px solid #FFD700'
            }}>
            <div className="container">
                <div className="row">
                    <div className="col-md-4 mb-3">
                        <h5 style={{ color: '#FFD700' }}>
                        🕉️ Yajman Pooja
                        </h5>
                        <p style={{ color: '#FFE4B5' }}>
                            Book experienced Brahmins for all your
                            religious ceremonies with ease and trust.
                        </p>
                        <p style={{
                            color: '#FFD700',
                            fontStyle: 'italic'
                        }}>
                            ॐ सर्वे भवन्तु सुखिनः
                        </p>
                    </div>
                    <div className="col-md-4 mb-3">
                        <h5 style={{ color: '#FFD700' }}>
                            Quick Links
                        </h5>
                        <ul className="list-unstyled">
                            <li>
                                <a href="/"
                                    style={{ color: '#FFE4B5',
                                        textDecoration: 'none' }}>
                                    🏠 Home
                                </a>
                            </li>
                            <li>
                                <a href="/search"
                                    style={{ color: '#FFE4B5',
                                        textDecoration: 'none' }}>
                                    🔍 Find Poojari
                                </a>
                            </li>
                            <li>
                                <a href="/register"
                                    style={{ color: '#FFE4B5',
                                        textDecoration: 'none' }}>
                                    📝 Register as User
                                </a>
                            </li>
                            <li>
                                <a href="/poojari-register"
                                    style={{ color: '#FFE4B5',
                                        textDecoration: 'none' }}>
                                    🙏 Register as Poojari
                                </a>
                            </li>
                        </ul>
                    </div>
                                        <div className="col-md-4 mb-3">
                        <h5 style={{ color: '#FFD700' }}>
                            Contact Us
                        </h5>
                        <p style={{ color: '#FFE4B5' }}>
                            📧 yajmannamah@gmail.com
                        </p>
                        {/* ⚠️ Phone JAAN-BOOJH KE hata diya.
                            
                            Pehle yahan "+91 9999999999" tha - ek nakli
                            number jo kabhi badla nahi gaya. Wo Play
                            Store pe live tha, aur galat contact info
                            policy ki dikkat ban sakti hai.
                            
                            Asli number bhi nahi daala: abhi ek hi banda
                            hai jo poojari onboarding mein bahar rehta
                            hai. Phone dikha ke na uthana usse bhi bura
                            hai. Email kaafi hai - wahi Play Store pe
                            bhi diya hai. */}
                        <p style={{ color: '#FFE4B5' }}>
                            📍 Bhubaneswar, Odisha
                        </p>
                    </div>
                </div>
                <hr style={{ borderColor: '#FFD700' }} />
                <div className="text-center"
                    style={{ color: '#FFE4B5' }}>
                    <p className="mb-0">
                        © 2026 Yajman Pooja.
                        All rights reserved. 🙏
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;